export default (state, { payload }) => ({
  ...state,
  recommendationsRequestId: payload
});
